import React from 'react';

const LeftEnhancerName = 'LeftEnhancer' as const;

const LeftEnhancer: React.FC = ({children}) => {
  return <>{children}</>;
};

LeftEnhancer.displayName = LeftEnhancerName;

export {LeftEnhancer, LeftEnhancerName};
